import { ReactNode } from 'react';

export const renderNTimes = (
  n: number,
  cb: (_value: unknown, _index: number, _array: unknown[]) => ReactNode
): ReactNode => Array.from(Array(n)).map(cb);
